export function cleanHostName(host = "", capitalize = false) {
  const cleaned = host.replace("www.", "").replace(/:.*$/, "");
  if (!capitalize) {
    return cleaned;
  }
  return cleaned.length > 0
    ? `${cleaned[0].toUpperCase()}${cleaned.slice(1)}`
    : cleaned;
}
